var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.6976 17.8438C6.56842 17.8438 7.28187 18.5724 7.28187 19.4724C7.28187 20.3618 6.56842 21.0904 5.6976 21.0904C4.81629 21.0904 4.10284 20.3618 4.10284 19.4724C4.10284 18.5724 4.81629 17.8438 5.6976 17.8438ZM17.5009 17.8438C18.3717 17.8438 19.0852 18.5724 19.0852 19.4724C19.0852 20.3618 18.3717 21.0904 17.5009 21.0904C16.6196 21.0904 15.9061 20.3618 15.9061 19.4724C15.9061 18.5724 16.6196 17.8438 17.5009 17.8438Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.817137 0.0899461L0.924059 0.0987698L3.42636 0.484507C3.78308 0.549868 4.04538 0.848815 4.07685 1.21312L4.2762 3.61327C4.30767 3.95721 4.58046 4.21437 4.9162 4.21437H19.0854C19.7254 4.21437 20.1451 4.43939 20.5648 4.93227C20.9844 5.42516 21.0579 6.13234 20.9634 6.77417L19.9667 13.8032C19.7779 15.1543 18.6447 16.1497 17.3123 16.1497H5.86571C4.47029 16.1497 3.31619 15.0568 3.20078 13.6435L2.23554 1.96317L0.651272 1.68458C0.231599 1.60957 -0.0621723 1.19169 0.0112705 0.763095C0.0847132 0.323783 0.493894 0.0344803 0.924059 0.0987698L0.817137 0.0899461ZM15.6336 8.17782H12.7274C12.2867 8.17782 11.9405 8.53142 11.9405 8.98144C11.9405 9.42075 12.2867 9.78506 12.7274 9.78506H15.6336C16.0743 9.78506 16.4205 9.42075 16.4205 8.98144C16.4205 8.53142 16.0743 8.17782 15.6336 8.17782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon03);
export default __webpack_public_path__ + "static/media/sidebar-icon-03.bd1e1a3ac7915739d845af2727ce5e74.svg";
export { ForwardRef as ReactComponent };